<template>
  <div class="safe">
    <div class="header">
    	<div class="header-layout">
    		<h1 class="logo" id="logo">
    			<a href="http://www.ddzzii.com"></a>
    		</h1>
    		<a class="logo-title"> {{ivActionType}} </a>
    		<ul class="header-nav" v-if="this.$cookies.isKey('token') === false">
    			<li class="li-first">
    				<a href="">注册</a>
    			</li>
    			<li>
    				<a href="">登录</a>
    			</li>
    			<li>
    				<a href="/index">首页</a>
    			</li>
    			<li>
    				<a href="">帮助中心</a>
    			</li>
    		</ul>
    		<ul class="header-nav" v-if="this.$cookies.isKey('token')">
    			<li class="li-first">
    				<div>您好，{{$store.state.username}}</div>
    			</li>
    			<li>
    				<a class="logout" @click="$api.user.logout()">退出</a>
    			</li>
    			<li>
    				<a href="/index">首页</a>
    			</li>
    			<li>
    				<a href="">帮助中心</a>
    			</li>
    		</ul>
    	</div>
    </div>
  	<div class="content">
		<div class="maincenter">
			<div>
				<el-steps :active="step" align-center process-status="finish" finish-status="success" class="authc-steps">
					<el-step title="验证身份"></el-step>
					<el-step :title="ivActionType"></el-step>
					<el-step title="完成"></el-step>
				</el-steps>
			</div>
			<div class="maincenter-box">
				<div style="width: 80%;margin:0 auto;font-size: 14px;border-bottom: 1px solid #b9b9b9;">{{$store.state.username}}</span>密码已修改完成</div>
				<div class="form">
					<div class="DJS">{{time}}秒后将自动跳转......</div>
				</div>
			</div>
		</div>
  	</div>
  	<footer-layout></footer-layout>
  </div>
</template>

<script>
  import BaseUserInfo from '@/components/form/BasicInfoForm'
  import AddrThreeSelect from '@/components/fields/AddrThreeSelect'
  import FooterLayout from '@/components/layout/FooterLayout'
  export default {
    name: 'FinishReset',
    components: {FooterLayout, AddrThreeSelect, BaseUserInfo},
    data() {
      return {
		ivActionType: '',
		step: 3,
		formKey: '',
		time: 5,
        industries: [],
        errors: {
          name: '',
          idcard: '',
          addr: '',
          industry: '',
        },
        formData: {
          name: '',
          idcard: '',
          addr: '',
          industry: '',
        },
      }
    },
    methods: {
    },
    created() {
	  this.ivActionType = window.localStorage.getItem('ivActionType')
	  console.log(this.ivActionType)
	  switch (this.ivActionType) {
	  	case ('password_reset') :
	  		this.ivActionType = '找回密码'
	  		break
	  	case ('password_modify') :
	  		this.ivActionType = '修改密码'
	  		break
		case ('help_email_modify') :
			this.ivActionType = '修改安全邮箱'
			break
	  }
	  this.timer = setInterval(()=> {
		  console.log(this.time)
	    if (this.time === 0) {
			clearInterval(this.timer)
			this.$router.push({path: '/secure'})
	    }else {
	      this.time--
	    }
	  }, 1000)
    }
  }
</script>

<style>
.form-input .el-input__inner{
	border-radius: 0px;
}
</style>

<style scoped>
  .authc-steps {
    margin-top: 40px;
  	margin-bottom: 30px;
  }
  .safe .content{
  	width: 990px;
  	/* height: 1050px; */
  	margin: 0 auto;
  	font-size: 12px;
  }
  .maincenter-box .form{
	height: 300px;
  }
  .maincenter-box {
  	margin: 0 auto;
  	padding: 20px 0;
  	width: 774px;
  	height: auto;
  }
  .form{
  	  margin-top: 60px;
  }
  .DJS{
	  font-size: 14px;
	  width: 130px;
	  margin: 0 auto;
  }
  .footer {
  	 text-align: center;
  	 width: 120px;
  	 margin: 30px auto;
  }
</style>
